<template>
	<div class="frame" ref="room"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'PlayerLiveClassJitsi',

	props: ['activity'],

	data() {
		return {
			api: null,
			domain: '8x8.vc',
			height: '100%',
			options: {
				parentNode: '',
				roomName: `vpaas-magic-cookie-6afe6fa648974f05a26593b85ed358c3/${this.activity.code_room}`,
				userInfo: {
					email: '',
					displayName: '',
				},
				configOverwite: {
					subject: this.activity.title,
					disableDeepLinking: true,
					prejoinPageEnabled: false,
					startWithAudioMuted: true,
					startWithVideoMuted: true,
					fileRecordingsEnabled: false,
					constraints: {
						video: {
							height: {
								ideal: 360,
								max: 480,
								min: 240,
							},
						},
					},
					disableKick: true,
				},
				interfaceConfigOverwrite: {
					SHOW_CHROME_EXTENSION_BANNER: false,
					DISPLAY_WELCOME_PAGE_CONTENT: false,
					LANG_DETECTION: true,
					CLOSE_PAGE_GUEST_HINT: false,
					HIDE_KICK_BUTTON_FOR_GUESTS: true,
					TOOLBAR_BUTTONS: [
						'microphone',
						'camera',
						'hangup',
						'closedcaptions',
						'fullscreen',
						'profile',
						'chat',
						'raisehand',
						'videoquality',
						'tileview',
					],
				},
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			name: 'common/full_name',
			email: 'common/email',
		}),
	},

	methods: {
		initialConfig() {
			this.setUserInfo()
			this.addCustomFunctions()
			this.api.executeCommand('setVideoQuality', 360)
			this.api.executeCommand('toggleVideo')
			this.api.executeCommand('toggleAudio')
		},

		setUserInfo() {
			this.api.executeCommand('email', this.email)
			this.api.executeCommand('displayName', this.name)
		},

		addCustomFunctions() {
			this.api.on('participantJoined', this.newParticipant)

			this.api.on('readyToClose', this.endMeeting)
		},

		newParticipant({ displayName }) {
			this.$q.notify({
				message: `${displayName} ${this.$t('joined_the_class')}`,
				type: 'positive',
				icon: 'fal fa-user-plus',
				position: 'left',
			})
		},

		endMeeting() {
			this.api.dispose()
			this.$emit('hideModalClassRoom')
		},
	},

	created() {
		if (!this.activity?.status === 4) {
			this.$mitt.emit('openLiveClass', this.activity)
		}
	},

	beforeDestroy() {
		this.$mitt.emit('setUserOfflineFirebase', this.activity)

		this.api.dispose()
	},

	async mounted() {
		await this.jitsi()
		this.options.parentNode = this.$refs.room
		this.api = new JitsiMeetExternalAPI(this.domain, this.options)

		this.initialConfig()
	},
}
</script>

<style lang="scss" scoped>
.frame {
	height: 60vh;
	iframe {
		width: 100%;
		height: 60vh;
	}
}
</style>
